"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationDocument = void 0;
var types_1 = require("../../../types");
exports.locationDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        actions: [],
        allowedDocumentEditor: "DOCUMENT_CREATOR",
        defenses: [],
        displayConditions: [],
        formSubmissionConstraint: null,
        id: 1190852,
        isRehuddleEligible: true,
        lastModifiedDate: "2021-07-14T19:22:33.461131Z",
        name: "Location Tester",
        properties: null,
        relationshipTypes: [],
        rootId: 1175401,
        sections: [
            {
                id: 1176251,
                items: [
                    {
                        id: 1176351,
                        includeMap: true,
                        questions: [
                            {
                                answerSource: null,
                                iconColor: "#0072CE",
                                id: 1175902,
                                questionRootId: 589901,
                            },
                            {
                                answerSource: null,
                                iconColor: "#0072CE",
                                id: 1175802,
                                questionRootId: 589903,
                            },
                        ],
                        rootId: 1176351,
                        subType: "MAP",
                        type: "WIDGET",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "WORK_LOCATION",
                            id: 739701,
                            isFromWidget: null,
                            properties: {
                                answerField: "name",
                                autoComplete: true,
                                displayField: "name",
                                detailedSearch: {
                                    title: "Work Location",
                                    enabled: true,
                                    linkName: "Search Work Locations",
                                    searchBy: "Search by Location Name",
                                    subtitle: "Where are you working today?",
                                    infiniteListTitle: "Work Locations by Alphabetical Order",
                                    infiniteListSortBy: "name",
                                    recentAnswersTitle: "Recently Searched Work Locations",
                                    customAnswerEnabled: true,
                                    infiniteListEnabled: true,
                                    recentAnswersEnabled: true,
                                },
                                associatedLocationField: "geolocation",
                            },
                            type: "DATA_SOURCE",
                        },
                        hasDefenses: false,
                        id: 739651,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2020-10-06T19:54:59.290579Z",
                        parentWidgetRootId: 1176351,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {
                            assistiveText: "Type street address or use Search Work Locations lookup",
                            placeHolderText: "Work Location Placeholder",
                        },
                        rootId: 589901,
                        selections: [],
                        subType: "LOCATION",
                        tags: [],
                        title: "Work Location",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: null,
                            id: 739951,
                            isFromWidget: null,
                            properties: {
                                autoComplete: false,
                                detailedSearch: {
                                    enabled: true,
                                    linkName: "Find My Geo Location",
                                },
                            },
                            type: "CURRENT_GPS",
                        },
                        formProperties: {
                            id: 1191071,
                            isCloneable: true,
                            isRequired: true,
                            isSearchable: false,
                            questionRootId: 589903,
                        },
                        hasDefenses: false,
                        id: 739901,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2020-10-06T19:54:59.306895Z",
                        parentWidgetRootId: 1176351,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {
                            assistiveText: "Use Find My Geo to customize 911 address or drag map pins to refine your position",
                            placeHolderText: "911 Address Placeholder",
                        },
                        rootId: 589903,
                        selections: [],
                        subType: "LOCATION",
                        tags: [],
                        title: "911 Address",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                ],
                parentWidgetRootId: null,
                properties: null,
                rootId: 1175501,
                title: "Location Test Document",
                workflowType: "FINAL",
            },
        ],
        sharingEnabled: true,
        signatureRequired: null,
        startFromWorkOrderEnabled: true,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1195001,
        name: "Some Location Questions",
        rootId: 1195001,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'User, Some"',
        name: "Some User",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=locationDocument.js.map